export default "__VITE_ASSET__CwcGFddl__"